import { trackException, trackSelectContent } from '../integrations/gtm';

export function useAnalytics() {
  return { trackException, trackSelectContent };
}